import PrimeReact, {addLocale, locale} from "primereact/api";
import {UtilService} from "@xal3xfx/react-utils";
import * as Yup from "yup";
import {IDropdownOption} from "@xal3xfx/react-utils/dist/util-service";

export enum EmployeeType {
    Driver = 1
}

export const employeeScheduleUrl = "https://docs.google.com/spreadsheets/d/1V8mmloMwqY2-9s4HlzqaxSj7hwNvXQWY8XGIbb4j-ec/edit?usp=sharing";

export const configureApp = (f: any) => {
    UtilService.setIntlFormatter(f);
    UtilService.setPrimeflexVersion(3);
    locale("bg");

    Yup.setLocale({
        mixed: {
            required: (params) => `${f({ id: params.path.split('.').at(-1) })} ${f({id: 'isRequired'})}`,
            notType: (params) => `${f({ id: params.path.split('.').at(-1) })} ${f({id: 'isRequired'})}`,
        },
        string: {
            length: (params) => `${f({id: params.path.split('.').at(-1)})} ${f({id: 'mustContainAtLeast'})} ${params.length} ${f({id: 'characters'})}`
        },
        number: {
            positive: (params) => `${f({id: params.path.split('.').at(-1)})} ${f({id: 'mustBePositive'})}`
        },
        array: {
            min: (params) => `${f({id: params.path.split('.').at(-1)})} ${f({id: 'mustHaveAtLeast'}, {min: params.min})}`
        }
    })

    addLocale('bg', {
        firstDayOfWeek: 1,
        dayNames: ["Неделя", "Понеделник", "Вторник", "Сряда", "Четвъртък", "Петък", "Събота"],
        dayNamesShort: ["Нд", "Пн", "Вт", "Ср", "Чет", "Пт", "Сб"],
        dayNamesMin: ["Н", "П", "В", "С", "Ч", "П", "С"],
        monthNames: ["Януари", "Февруари", "Март", "Април", "Май", "Юни", "Юли", "Август", "Септември", "Октомври", "Ноември", "Декември"],
        monthNamesShort: ["Ян", "Фев", "Март", "Апр", "Май", "Юни", "Юли", "Авг", "Сеп", "Окт", "Ноем", "Дек"],
        today: 'Днес',
        clear: 'Изчисти',
        dateFormat: 'dd-mm-yy',
        // dateFormat: 'dd.mm.yy',
        weekHeader: 'Сед'
    });
}
